import { useEffect, useState } from 'react';
import api from '../lib/api';

export default function ProtectedContentImage({ url, alt = '' }) {
  const internal = typeof url === 'string' && url.startsWith('/api/files/');
  const [loaded, setLoaded] = useState(null);
  useEffect(() => {
    if (!internal) return undefined;
    let active = true;
    let objectUrl;
    api.get(url.slice(4), { responseType: 'blob' }).then(({ data }) => {
      if (!active) return;
      objectUrl = URL.createObjectURL(data);
      setLoaded({ url, src: objectUrl });
    }).catch(() => { if (active) setLoaded({ url, error: true }); });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url, internal]);

  if (internal && loaded?.url !== url) return <span role="status">Caricamento immagine…</span>;
  if (internal && loaded?.error) return <span role="status">Immagine non disponibile.</span>;
  return <img src={internal ? loaded.src : url} alt={alt} className="w-full max-h-[80vh] object-cover rounded-2xl" loading="lazy" />;
}
